/**
 * useServiceOrderInsights - Fatos da subaba Indicadores (RPC `get_service_order_insights`).
 * Chave sob ['service-orders'] para o tempo real da O.S. aberta invalidar junto.
 *
 * RELEASE: 2026-10-18 v1.0.0 - Versão inicial (BR-OS-055).
 */
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';
import type { ServiceOrderInsightsFacts } from '@/lib/serviceOrders/insights';

const rpc = (fn: string, args: Record<string, unknown>) =>
  (supabase.rpc as unknown as (f: string, a: Record<string, unknown>) => Promise<{ data: any; error: any }>).call(supabase, fn, args);

export function useServiceOrderInsights(orderId: string | null | undefined, enabled = true) {
  const { currentTenant } = useAuth();
  const hint = currentTenant?.id ?? null;
  return useQuery({
    queryKey: ['service-orders', 'insights', hint, orderId],
    enabled: enabled && !!orderId && !!hint,
    queryFn: async () => {
      const { data, error } = await rpc('get_service_order_insights', { p_order_id: orderId, p_tenant_hint: hint });
      if (error) throw error;
      return data as ServiceOrderInsightsFacts;
    },
  });
}
